module.exports = __webpack_public_path__ + "img/arrow-next-white.ea5ddfca.svg";